<template>
  <div class="alert__modal">
    <img class="alert__img" src="@/assets/icons/shared/i-alert.svg" />
    <div class="alert__title">{{ alertModel.alertTitle }}</div>
    <div class="alert__text">{{ alertModel.alertText }}</div>
    <div v-if="alertModel.buttonLinkText" class="alert__btn" @click="openLink">
      <p>{{ alertModel.buttonLinkText }}</p>
    </div>
    <div class="alert__btn" @click="onAlertHide">
      {{ alertModel.closeButtonText }}
    </div>
  </div>
</template>

<script>
import useAlert from "@/composables/useAlert";

export default {
  setup() {
    return useAlert();
  },
};
</script>

<style lang="scss" scoped>
* {
  &::first-letter {
    text-transform: capitalize;
  }
}

.alert__modal {
  font-family: Roboto-Regular;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  background: #f0f0f0;

  width: 270px;
  height: auto;
  max-height: 100%;
  padding: 30px 0 0 0;

  .alert__img {
    width: 36.2px;
    height: 32.46px;
    margin: 0 auto 13px;
  }

  .alert__title {
    margin-bottom: 12px;
    padding: 0 16px 0 16px;

    line-height: 20px;
    font-size: 17px;
    text-align: center;
    color: #000;
  }

  .alert__text {
    margin-top: 12px;
    margin-bottom: 30px;
    padding: 0 22px 0 22px;

    line-height: 16px;
    font-size: 14px;
    text-align: center;
    color: #000;
  }

  .alert__btn {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    padding: 10px 0;
    width: 100%;
    min-height: 44px;

    border-top: 1px solid #ddd;
    border-radius: 0;

    font-size: 14px;
    background: #fff;
    text-align: center;
    color: #0089d0;

    cursor: pointer;

    transition: all 200ms linear;

    p {
      margin: 0;

      &::first-letter {
        text-transform: uppercase !important;
      }
    }

    &:active {
      color: #fff;

      background: #2c699c;
      border-color: #2c699c;
      text-decoration: none;
    }

    &:focus {
      outline: none;
    }
  }
}
</style>
